var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:(_vm.pos)},_vm._l((_vm.infoTips),function(item,index){return _c('div',{key:index},[_c('div',[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }